<app-main-app-page [fluid]="false">
    <app-my-walls [enablePost]="true"></app-my-walls>
</app-main-app-page>